import React from 'react';

interface OnlineStatusIndicatorProps {
  size?: number; // size in pixels
  bgColor?: string; // background color for the main dot
  pingColor?: string; // background color for the ping effect
}

const OnlineStatusIndicator: React.FC<OnlineStatusIndicatorProps> = ({ 
  size = 8, 
  bgColor = '#22c55e', // default to green-500
  pingColor = '#4ade80' // default to green-400
}) => {
  const outerStyle = {
    width: size,
    height: size
  };

  return (
    <span className="relative flex" style={outerStyle}>
      <span
        className="absolute inline-flex animate-ping rounded-full opacity-75"
        style={{ ...outerStyle, backgroundColor: pingColor }}
      />
      <span
        className="relative inline-flex rounded-full"
        style={{ ...outerStyle, backgroundColor: bgColor }}
      />
    </span>
  );
};

export default OnlineStatusIndicator;